import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  Input,
} from '@angular/core';
import { BouncingDotsSize } from './bouncing-dots.types';

/**
 * Three staggered bouncing dots — the recognisable "native chat" typing cue.
 */
@Component({
  standalone: true,
  selector: 'fl-bouncing-dots',
  template: `
    <span class="BouncingDots-dot"></span>
    <span class="BouncingDots-dot"></span>
    <span class="BouncingDots-dot"></span>
  `,
  styleUrls: ['./bouncing-dots.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BouncingDotsComponent {
  @HostBinding('attr.aria-hidden') ariaHidden = true;

  @Input()
  @HostBinding('attr.data-size')
  size = BouncingDotsSize.SMALL;
}
